import { TokenWithValue } from '@/domain/common/types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { SuccessViewPanelTitle } from '@/features/dialogs/common/components/success-view/SuccessPanelTitle'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewPanel } from '@/features/dialogs/common/components/success-view/SuccessViewPanel'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewTokenRow } from '@/features/dialogs/common/components/success-view/SuccessViewTokenRow'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

export interface SuccessViewProps {
  borrowAsset: TokenWithValue
  outputAsset: TokenWithValue
  onProceed: () => void
  proceedText: string
  className?: string
  successViewProceedButtonDataTestId?: string
}
export function SuccessView({
  borrowAsset,
  outputAsset,
  onProceed,
  proceedText,
  className,
  successViewProceedButtonDataTestId,
}: SuccessViewProps) {
  return (
    <SuccessViewContent className={className}>
      <SuccessViewCheckmark />
      <SuccessViewPanel className="gap-4">
        <div className="flex flex-col" data-testid={testIds.dialog.borrow.success.borrowed}>
          <SuccessViewPanelTitle>Borrowed</SuccessViewPanelTitle>
          <SuccessViewTokenRow token={borrowAsset.token} amount={borrowAsset.value} />
        </div>
        {outputAsset.token.symbol === TokenSymbol('USDC') && borrowAsset.token.symbol === TokenSymbol('USDS') && (
          <div className={cn('flex flex-col md:flex-row md:gap-9')}>
            <div className="flex grow flex-col" data-testid={testIds.dialog.borrow.success.swappedFrom}>
              <SuccessViewPanelTitle>Swapped from</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={borrowAsset.token} amount={borrowAsset.value} />
            </div>
            <div className="flex grow flex-col" data-testid={testIds.dialog.borrow.success.swappedTo}>
              <SuccessViewPanelTitle>To</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={outputAsset.token} amount={outputAsset.value} />
            </div>
          </div>
        )}
      </SuccessViewPanel>
      <SuccessViewProceedButton onProceed={onProceed} dataTestId={successViewProceedButtonDataTestId}>
        {proceedText}
      </SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
